import { render, staticRenderFns } from "./CenterEdit.vue?vue&type=template&id=5903d4dc&"
import script from "./CenterEdit.vue?vue&type=script&lang=js&"
export * from "./CenterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports